function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m447.1 155.83-45.16 343.13c-.98 7.46-7.34 13.04-14.87 13.04h-262.14c-7.53 0-13.89-5.58-14.87-13.04l-45.16-343.13c-1.194-8.966 5.798-16.95 14.87-16.95h352.46c9.081 0 16.063 7.993 14.87 16.95z",
  fill: "#dfe7f4"
})), /*#__PURE__*/React.createElement("path", {
  d: "m447.1 155.83-45.16 343.13c-.98 7.46-7.34 13.04-14.87 13.04h-131.07v-373.12h176.23c9.081 0 16.063 7.993 14.87 16.95z",
  fill: "#c7cfe1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m258.66 0h-5.32c-37.13 0-67.34 30.21-67.34 67.33v20.92c0 8.28 6.72 15 15 15h110c8.28 0 15-6.72 15-15v-20.92c0-37.12-30.21-67.33-67.34-67.33zm37.34 78.725h-80v-11.395c0-20.58 16.75-37.33 37.34-37.33h5.32c20.59 0 37.34 16.75 37.34 37.33z",
  fill: "#6aa9ff"
})), /*#__PURE__*/React.createElement("path", {
  d: "m326 67.33v20.92c0 8.28-6.72 15-15 15h-55v-24.525h40v-11.395c0-20.58-16.75-37.33-37.34-37.33h-2.66v-30c43.414 0 70 32.911 70 67.33z",
  fill: "#4987ea"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m271 224.73v201.41c0 8.29-6.72 15-15 15s-15-6.71-15-15v-201.41c0-8.28 6.72-15 15-15s15 6.72 15 15z",
  fill: "#7ed8f6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m188.328 441.143c-7.649 0-14.183-5.823-14.916-13.591l-19.018-201.409c-.779-8.248 5.276-15.565 13.523-16.344 8.254-.776 15.565 5.276 16.344 13.523l19.018 201.409c.779 8.248-5.276 15.565-13.523 16.344-.48.046-.956.068-1.428.068z",
  fill: "#7ed8f6"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m323.672 441.143c-.472 0-.948-.022-1.428-.067-8.248-.779-14.302-8.096-13.523-16.344l19.018-201.409c.778-8.248 8.086-14.305 16.344-13.523 8.248.779 14.302 8.096 13.523 16.344l-19.018 201.409c-.734 7.767-7.268 13.59-14.916 13.59z",
  fill: "#6aa9ff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m469.35 88.25v65.63c0 8.28-6.71 15-15 15h-396.7c-8.29 0-15-6.72-15-15v-65.63c0-8.29 6.71-15 15-15h396.7c8.29 0 15 6.71 15 15z",
  fill: "#7ed8f6"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#6aa9ff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m469.35 88.25v65.63c0 8.28-6.71 15-15 15h-198.35v-95.63h198.35c8.29 0 15 6.71 15 15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 224.73v201.41c0 8.29-6.72 15-15 15v-231.41c8.28 0 15 6.72 15 15z"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 512 512",
  height: 512,
  viewBox: "0 0 512 512",
  width: 512
}, props), _ref);

export default __webpack_public_path__ + "static/media/bin.ed11d8b2.svg";
export { SvgComponent as ReactComponent };